<template>
  <!--  干支线业务-->
  <div class="mb10">
    <div class="mb10 feet-r">
      <!-- 增加一行 -->
      <el-button
        size="small"
        type="primary"
        @click="handleAdd"
      >{{ $t('basicData.AddARow') }}</el-button>

      <!-- 下载/导入 -->
      <ImportAndDownloadCmp
        :fee-type-list="feeTypeList"
        :stitching-line="stitchingLine"
        :model-list="modelList"
        :quotation-type="quotationType"
        :get-data-func="onDownloadOffer"
        @importList="onImportList"
      />

      <!-- 清空报价 -->
      <el-popover
        placement="bottom-start"
        trigger="hover"
      >
        <div class="feet">
          <!--清空当前车线-->
          <el-button
            v-if="quotationType === 1"
            size="small"
            type="primary"
            class="feet-btn"
            @click="onClear"
          >{{ $t('basicData.EmptyCurrentPartition') }}
          </el-button>
          <!--清空所有车线-->
          <el-button
            size="small"
            type="primary"
            class="feet-btn"
            @click="onAllClear"
          >{{ $t('basicData.EmptyAllPartitions') }}
          </el-button>
        </div>
        <!--清空报价-->
        <template #reference>
          <el-button size="small">{{ $t('basicData.ClearTheOffer') }}</el-button>
        </template>
      </el-popover>
    </div>

    <!--车线报价 -->
    <TableCmp
      ref="defaultTableRef"
      :fee-type-list="feeTypeList"
      :model-list="modelList"
      :table-data="getPartitionArr"
      @change="changePartition"
    />
  </div>
</template>

<script>
import { TMP_OBJ, SEPARATOR, setPartitionFun, validate } from './utils';
import { cloneDeep } from 'lodash-es';

const QUOTATION_MODE_FIXED = 4; // 固定报价模式

export default {
  components: {
    ImportAndDownloadCmp: () => import('./importAndDownloadCmp.vue'),
    TableCmp: () => import('./TableCmp.vue')
  },

  props: {
    // 车线id-通用报价无id
    partitionAffiliateId: {
      type: [String, Number],
      default: ''
    },

    // 所有车型
    modelList: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 所有车线
    stitchingLine: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 费用类型
    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 报价类型 1 车线报价 2 通用报价
    quotationType: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      // 车线报价
      partitionObj: {},
      // 通用报价-无车线
      partitionArr: []
    };
  },

  computed: {
    // 监听partitionObj变化
    getPartitionArr() {
      // 车线报价：根据选中的车线ID返回对应数据
      if (this.quotationType === 1) {
        const row = this.partitionObj[this.partitionAffiliateId];
        if (this.partitionAffiliateId && row && row.arr) {
          return this.partitionObj[this.partitionAffiliateId].arr || [];
        }
        return [];
      }
      // 通用报价：直接返回partitionArr
      return this.partitionArr;
    }
  },

  watch: {
    // 监听车线ID
    stitchingLine: {
      handler(val) {
        this.initPartitionObj();
      },
      deep: true,
      immediate: true
    },
    // 监听报价类型
    quotationType: {
      handler(val) {
        this.initPartitionObj();
      },
      immediate: true
    }
  },

  methods: {
    // 初始化分区对象
    initPartitionObj() {
      console.log('initPartitionObj', this.quotationType, this.stitchingLine);

      if (this.quotationType === 1) {
        // 选择了车线报价 但是车线没有数据
        if (!this.stitchingLine || this.stitchingLine.length === 0) {
          return;
        }

        // 【检查是否已存在相同的车线结构，避免重复创建】
        const existingIds = Object.keys(this.partitionObj).map(Number);
        const newIds = this.stitchingLine.map(item => item.id);

        // 如果车线列表完全相同，无需重建
        if (existingIds.length === newIds.length &&
            existingIds.every(id => newIds.includes(id))) {
          console.log('车线结构未变化，跳过重建');
          return;
        }

        // 先将之前的数据清空
        for (const key in this.partitionObj) {
          this.$delete(this.partitionObj, key);
        }

        // 初始化
        this.stitchingLine.forEach(item => {
          this.$set(this.partitionObj, item.id, {
            arr: []
          });
        });
      } else {
        // 通用报价
        this.partitionArr = [];
      }
    },

    // 添加
    handleAdd() {
      try {
        // 车线报价
        if (this.quotationType === 1) {
          if (!this.partitionAffiliateId) {
            this.$message.warning(this.$t('basicData.pleaseSelectVehicleLine'));
            return;
          }

          // 增加防御性检查：确保车线已初始化
          if (!this.partitionObj[this.partitionAffiliateId]) {
            console.log('车线未初始化:', this.partitionObj);
            return;
          }

          this.partitionObj[this.partitionAffiliateId].arr.push({
            ...TMP_OBJ
          });
        } else {
          // 通用报价
          this.partitionArr.push({
            ...TMP_OBJ
          });
        }
      } catch (error) {
        console.log('添加行失败:', error);
      }
    },

    // table数据回调
    changePartition(arr) {
      // 车线报价
      if (this.quotationType === 1) {
        if (!this.partitionAffiliateId) {
          return;
        }
        console.log('table数据变化188', this.partitionAffiliateId, arr);
        this.partitionObj[this.partitionAffiliateId].arr = arr;
      } else {
        // 通用报价
        console.log('通用报价数据变化', arr);
        this.partitionArr = arr;
      }
    },

    /**
     * 提交校验
     *    1. 直接校验当前车线/通用报价
     *    2. 其他车线填写的数据校验（仅车线报价）
     */
    async submitForm() {
      // 【改动点7】添加加载状态，提升用户体验
      const loading = this.$loading({
        lock: true,
        text: '正在校验数据...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });

      try {
        // 车线报价
        if (this.quotationType === 1) {
          // 校验是否添加了数据
          {
            const arr = [];
            for (const key in this.partitionObj) {
              if (this.partitionObj[key].arr.length > 0) {
                arr.push(this.partitionObj[key].arr);
              }
            }

            if (arr.length === 0) {
              this.$message.warning(this.$t('basicData.PleaseAddDetails'));
              return false;
            }
          }

          // 先校验当前选中的车线
          {
            const isBool = await this.$refs.defaultTableRef.submitForm();
            if (!isBool) {
              this.$message.warning(this.$t('basicData.CheckFail'));
              return false;
            }
          }
          // 存在其他车线，校验
          {
            const arr = [];
            for (const key in this.partitionObj) {
              const isBool = validate(this.partitionObj[key].arr);
              if (!isBool) {
                arr.push(key);
              }
            }
            // 有校验不通过的车线
            if (arr.length > 0) {
              // 获取不通过的车线名称
              const list = this.stitchingLine.filter(item => {
                return arr.includes(String(item.id));
              }).map(item => {
                return item.name;
              }).join(',');

              this.$message.warning('关联车线《' + list + '》' + this.$t('basicData.CheckFail'));
              return false;
            }
          }
        } else {
          // 通用报价
          // 校验是否添加了数据
          if (this.partitionArr.length === 0) {
            this.$message.warning(this.$t('basicData.PleaseAddDetails'));
            return false;
          }

          // 校验当前通用报价数据
          const isBool = await this.$refs.defaultTableRef.submitForm();
          if (!isBool) {
            this.$message.warning(this.$t('basicData.CheckFail'));
            return false;
          }
        }

        return true;
      } finally {
        // 确保关闭loading
        loading.close();
      }
    },

    // 设置数据(主要是为父组件提供操作)
    async setData(arr) {
      console.log('setData-250', arr, 'quotationType:', this.quotationType);
      if (arr.length === 0) { return; }

      // 车线报价
      if (this.quotationType === 1) {
        const dataObj = cloneDeep(this.partitionObj);
        const row = await setPartitionFun(arr, dataObj);
        console.log(row, '解析后报价数据');
        for (const key in this.partitionObj) {
          this.partitionObj[key].arr = row[key] && row[key].arr ? row[key].arr : [];
        }
        console.log('车线报价', this.partitionObj);
      } else {
        // 通用报价
        console.log('通用报价数据', arr);
        this.partitionArr = arr;
      }
    },

    /**
     * 获取数据
     */
    getData() {
      const arr = [];

      // 车线报价，将所有数据（二维数组）放入arr（一维数组）中
      if (this.quotationType === 1) {
        Object.entries(this.partitionObj).forEach(([key, value]) => {
          // 跳过空数组
          if (value.arr.length === 0) return;

          console.log('车线报价', key, value);
          const list = value.arr.map(item => ({
            ...item,
            lineId: key,
            startDistance: item.quotationMode !== QUOTATION_MODE_FIXED ? item.startDistance : '', // 固定报价清除里程
            endDistance: item.quotationMode !== QUOTATION_MODE_FIXED ? item.endDistance : ''
          }));
          arr.push(...list);
        });
      } else {
        // 通用报价
        console.log('通用报价', this.partitionArr);
        this.partitionArr.forEach(item => {
          arr.push({
            ...item,
            startDistance: item.quotationMode !== QUOTATION_MODE_FIXED ? item.startDistance : '',
            endDistance: item.quotationMode !== QUOTATION_MODE_FIXED ? item.endDistance : ''
          });
        });
      }

      console.log('干支线报价325', arr);
      return arr.filter(item => item.feeTypeCode);
    },

    // 下载报价回调函数
    onDownloadOffer() {
      const list = this.getData();
      console.log('下载报价数据332', list);
      return list.map(item => {
        const { lineId } = item;

        const obj = {
          ...item
        };

        // 车线名称处理
        {
          const partitionAffiliateObj = this.stitchingLine.find(item => {
            return item.id === lineId;
          });
          if (partitionAffiliateObj) {
            const { name, id } = partitionAffiliateObj;
            obj.partitionAffiliateId = `${name}${SEPARATOR}${id}`;
          }
        }
        return obj;
      });
    },

    /**
     * 导入数据
     * @param {TTableRow[]} arr 导入返回的数据
     */
    onImportList(arr) {
      console.log('importList', arr);

      const list = arr.map(item => {
        let lineId = item.partitionAffiliateId;

        // 如果是车线报价且包含分隔符，需要提取ID部分
        if (this.quotationType === 1 && typeof lineId === 'string' && lineId.includes(SEPARATOR)) {
          const parts = lineId.split(SEPARATOR);
          // 取最后一部分作为ID（格式："车线名称->ID"）
          lineId = parts[parts.length - 1];
        }

        return {
          ...item,
          // 车线报价保留lineId，通用报价设为undefined
          lineId: this.quotationType === 1 ? lineId : undefined
        };
      });

      this.setData(list);
    },

    // 清空当前分区
    onClear() {
      // 车线报价
      if (this.quotationType === 1) {
        if (this.partitionAffiliateId && this.partitionObj[this.partitionAffiliateId]) {
          this.partitionObj[this.partitionAffiliateId].arr = [];
        }
      } else {
        // 通用报价
        this.partitionArr = [];
      }
    },

    // 清空所有报价
    onAllClear() {
      // 车线报价
      if (this.quotationType === 1) {
        for (const key in this.partitionObj) {
          this.partitionObj[key].arr = [];
        }
      } else {
        // 通用报价
        this.partitionArr = [];
      }
    }
  }
};
</script>
